import { Component, ElementRef, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Datum, Pie, PieOptions } from '@antv/g2plot';
import { UserApiService } from 'src/app/services/api/user-api.service';
import { CommissionDetailsModalComponent } from '../commission-details-modal/commission-details-modal.component';

@Component({
  selector: 'app-user-affiliate-order-pie-card',
  templateUrl: './user-affiliate-order-pie-card.component.html',
  styleUrls: ['./user-affiliate-order-pie-card.component.scss'],
})
export class UserAffiliateOrderPieCardComponent implements OnInit {
  constructor(
    private api: UserApiService,
    private el: ElementRef,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.findUserAffiliateOrderStats();
  }

  data: any[] = [];
  plot: Pie | null = null;
  loading = false;
  async findUserAffiliateOrderStats() {
    try {
      this.loading = true;
      const r = await this.api.findUserAffiliateUserOrderStats();
      this.data = r.data;
      if (this.data.length > 0) {
        this.render();
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  render() {
    if (!this.data) {
      return;
    }
    const cfg: PieOptions = {
      data: this.data,
      angleField: 'total_commission',
      colorField: 'platform_id',
      legend: false,
      // radius: 0.9,
      meta: {
        platform_id: {
          alias: '平台',
        },
      },

      autoFit: true,
      tooltip: {
        fields: ['count', 'platform', 'total_commission'],
        formatter: (datum: any) => {
          return {
            name: datum.platform.name,
            value: `￥${datum.total_commission}(${datum.count}单)`,
          };
        },
      },
      label: {
        type: 'inner',
        autoRotate: true,
        content: (data: any) =>
          `${data.platform.name}:￥${data.total_commission}`,
        style: {
          fontSize: 14,
          textAlign: 'center',
        },
      },
      interactions: [{ type: 'element-active' }],
    };
    if (!this.plot) {
      this.plot = new Pie(
        this.el.nativeElement.querySelector('#container'),
        cfg
      );
    } else {
      this.plot.update(cfg);
    }
    this.plot.render();
  }

  openModal() {
    this.dialog.open(CommissionDetailsModalComponent, {
      width: '726px',
    });
  }
}
